import React from 'react';
import { Theme as AugmentedTheme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

import { useTranslation } from 'react-i18next';
import { Typography } from 'web-library';

const useStyles = makeStyles()((theme) =>
({
  description: {
    marginBottom: theme.spacing(4),
  },
  header: {
    marginBottom: theme.spacing(1),
    color: theme.color.text.textHeader,
    fontWeight: 'bold',
  },
  value: {
    marginBottom: theme.spacing(4),
  },
}));

interface PendingApplicationDetailsProps {
  applicationNo: string;
  examLevel: string;
}

const PendingApplicationDetails = ({
  applicationNo,
  examLevel,
}: PendingApplicationDetailsProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <>
      <Typography variant="body1" className={classes.description}>
        {t('accessArrangement->>Notes.PendingApplicationDescription')}
      </Typography>
      <Typography variant="body1" className={classes.header}>
        {t('accessArrangement->>Notes.ApplicationNo')}
      </Typography>
      <Typography variant="body1" className={classes.value}>
        {applicationNo}
      </Typography>
      <Typography variant="body1" className={classes.header}>
        {t('accessArrangement->>Notes.ExamLevels')}
      </Typography>
      <Typography variant="body1" className={classes.value}>
        {examLevel}
      </Typography>
    </>
  );
};

export default PendingApplicationDetails;
